<template>
    <div class="talk-over">
        <h3>剧本洽谈</h3>
        <textarea v-model="msg" placeholder="请输入您想对作者说的话"></textarea>
        <p class="error-message">{{errorMessage}}</p>
        <button :class="{'send-msg':true,'messageSending':messageSending}" :disabled="sendDisabled" ref="sendBtn" @click="sendMessage">发送</button>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name:'TalkOver',
    data(){
        return{
            msg:'',                  //发送内容
            sendDisabled:false,      //控制发送按钮可点击状态
            messageSending:false,    //发送中按钮样式
            errorMessage:''           //未输入内容报错信息
        }
    },
    methods:{
        sendMessage(){
            if(this.msg==''){
                this.errorMessage="请输入您想对作者说的话"
            }else{
                this.sendDisabled=true
                this.messageSending=true
                this.$refs.sendBtn.innerHTML="发送中..."
                Axios.post('/connect/author/',{article_id:this.$route.query.id,contents:this.msg})
                .then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.sendDisabled=false
                            this.messageSending=false
                            this.$refs.sendBtn.innerHTML="发送"
							this.msg=""
							this.$swal({
								text:'发送成功',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1000,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							});
							setTimeout(()=>{
								this.$router.go(-1)
							},1000)
                        }
                    }
                ).catch(
                    error=>{
                        this.sendDisabled=false
                        this.messageSending=false
                        this.$refs.sendBtn.innerHTML="发送"
                        this.$swal({
							text:'网络错误请稍后重试',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						});
                    }
                )
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .talk-over{
        padding:60px 54px;
        padding-top:168px;
        h3{
            font-size:30px;
            color:#222;
            font-weight:bold;
            margin-bottom:54px;
        }
        textarea{
            width:580px;
            height:400px;
            background:#F8F6F7;
            font-size:24px;
            color:#999;
            padding:40px 30px;
            border-radius:16px;
            border:none;
        }
        textarea::placeholder{
            color:#ccc !important;
        }
        .send-msg{
            width:640px;
            height:70px;
            line-height:70px;
            text-align:center;
            color:#fff;
            font-size:24px;
            background:#bf0000;
            border-radius:35px;
            border:none;
        }
        .send-msg:active{
            background:#dd8080;
        }
        .messageSending{
            background:#dd8080;
        }
        .error-message{
            padding-top:6px;
            color:#bf0000;
            font-size:24px;
            height:24px;
            margin-bottom:60px;
        }
    }
</style>